import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

export default function AccountsTable({ data }) {
  return (
    <TableContainer component={Paper} sx={{ my: 2, maxHeight: 240 }}>
      <Table
        sx={{ minWidth: { lg: 440, sm: 400, xs: 'auto' } }}
        aria-label='simple table'
        stickyHeader
      >
        <TableHead
          sx={{
            '& th': {
              fontWeight: '700',
              color: 'primary.main',
              py: 1
            }
          }}
        >
          <TableRow>
            {/* <TableCell>Account</TableCell> */}
            <TableCell>Bank</TableCell>
            <TableCell>Type&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow
              key={row.id}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '& td': { py: 1.5 }
              }}
            >
              {/* <TableCell component='td' scope='row'>
                {row.id}
              </TableCell> */}
              <TableCell>{row.bank}</TableCell>
              <TableCell>{row.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
